<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <v-card class="pa-4">
        <v-row justify="start">
          <v-col cols="6" xs="12" class="py-0">
              <span class="headline font-weight-light">Gerät <span v-if="formData">"{{formData.name}}"</span> </span>
          </v-col>
          <v-col cols="6" xs="12" style="text-align: right">
            <v-btn @click="close" icon color="red">
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      <v-tabs
      v-model="tab"
      background-color="#EEEEEE"
      color="black"
      @change="onChangeTab"
      grow
      >
        <v-tab>Allgemeine Daten</v-tab>
        <v-tab>Vorschau</v-tab>
        <v-tab>Aktuelle Playlist</v-tab>
        <v-tab v-if="hasSupport">Wartungsmanager</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <TabDefault ref="tabs0" :tagList="tagList" :form-data="formData"></TabDefault>
        </v-tab-item>
        <v-tab-item>
          <TabPreview ref="tabs1" :tagList="tagList" :device="formData" :companyId="companyId"></TabPreview>
        </v-tab-item>
        <v-tab-item>
          <TabPlaylist ref="tabs2"></TabPlaylist>
        </v-tab-item>
        <v-tab-item v-if="hasSupport && formData">
          <TabSupport ref="tabs3" :tagList="tagList" :device="formData" :companyId="companyId" @reloadDevice="reloadDevice"></TabSupport>
        </v-tab-item>
      </v-tabs-items>

    </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import TabDefault from "./TabDefault"
import TabPlaylist from "./TabPlaylist"
import TabPreview from "./TabPreview";
import TabSupport from "./TabSupport";
export default {
  name: 'DeviceDefault',
  components: {TabPreview, TabDefault, TabPlaylist, TabSupport},
  data () {
    return {
      appsList: [],
      tab: null,
      tagList: [],
      companyId: 0,
      company: null,
      playList: null,
      crump: [{
        text: 'Dashboard',
        disabled: false,
        href: '/#/Dashboard/Netzwerke',
      }],
      hasSupport: false,
      formData: {
        name: '',
        screenNumber: '',
        owner: '',
        playlist: '',
        phone: '',
        create: '',
        changed: ''
      },
      tag: '',
      tagac: '',
      tags: []
    }
  },
  methods: {
    onGetData: function (data) {
      console.log('deviceGuid', data)
      if (data.tags === null) {
        data.tags = '[]'
      }
      data.tags = JSON.parse(data.tags)
      if (!this.$route.params.companyId) {
        this.companyId = data.guidCompany
      }

      this.formData = data
    },
    onItemUpdated: function (data) {
      console.log('onItemUpdated', data)
      window.history.back();
    },
    onEnterTag: function () {
      this.formData.tags.push(this.$refs.acFields.internalSearch)
    },
    cancelItem: function () {
      this.$router.push('/Dashboard/Geraete')
    },
    updateItem: function () {
      Vue.prototype.$api.updateDevice(this.deviceGuid, this.formData, this.onItemUpdated)
    },
    close: function () {
      window.history.back();
    },
    reload: function () {
      Vue.prototype.$api.loadDevice(this.deviceGuid, this.onGetData)
    },
    reloadDevice: function (guid) {
      this.deviceGuid = guid
      this.reload()
    },
    onChangeTab: function() {
      if (this.$refs['tabs'+this.tab] && this.$refs['tabs'+this.tab].reload) {
        this.$refs['tabs'+this.tab].reload()
      }
    }
  },
  mounted () {
    this.deviceGuid = this.$route.params.deviceGuid
    if (this.$route.params.companyId) {
      this.companyId = this.$route.params.companyId
      this.crump.push({
          text: 'Unternehmen',
          href: '/#/Netzwerke/' + this.$route.params.companyId
        })
    }

    if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_SUPPORT')) {
      this.hasSupport = true
      this.tab = 3
    }
    this.reload()
  }
}
</script>

<style scoped>

</style>
